import React, { Fragment, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { useEffect } from 'react';

const Checkout = () => {

  const [user, setUser] = useState([]);
    useEffect(()=>{
      const auth_token = localStorage.getItem('auth_token');
      const selectedCurrency = localStorage.getItem('selectedCurrency');
        const data = {
            key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
            currency: selectedCurrency,
        }
      if (auth_token !== null) {
         axios.post('/apps-profile',data)
         .then(response=>{
           setUser(response.data)
           console.log(response.data)
           
           })
           .catch(error=>{
             console.log(error)
         })
      }

    },[])



  let balance;
  if (user == "") {
    console.log(user);
  }else{
    balance=user.data.balance;
  }

  const [depositInput, setDepositInput] = useState({
    amount: '',
    password: '',
    error_list: [],
  });

  const handleInput = (e) => {
    e.persist();
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  };

  const [loading, setLoading] = useState(false);

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      amount: depositInput.amount,
      password: depositInput.password,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9'
    };

    if (auth_token && !loading) {
      setLoading(true);
      axios.post(`/convert-balance`, data).then(res => {
        setLoading(false);
        if (res.data.status === 'success') {
          swal("Success", res.data.message, "success");
          setDepositInput({ amount: '', password: '', error_list: [] });
        } else if (res.data.status === 'fail') {
          swal("Warning", res.data.message, "warning");
        } else {
          setDepositInput({ ...depositInput, error_list: res.data.validation_error });
        }
      });
    }
  };

  return (
    <Fragment>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow rounded-4 border-0">
              <div className="card-body p-5">
                <h2 className="text-center mb-4 fw-bold text-primary">Convert Balance</h2>
                <p className="text-center text-muted mb-2">
                  Transfer your Main Wallet balance into your Principal Wallet securely.
                </p>
              
                <button
                  className="btn btn-lg w-100 text-white d-flex align-items-center justify-content-center gap-2 shadow  mb-3"
                  style={{
                    background: "#002f6a",
                    borderRadius: "14px",
                    transition: "0.3s",
                  }}
                >
                  <i className="fa fa-wallet fs-4"></i>
                  <span className="fs-3 fw-bold">Balance:  ${Number(balance).toFixed(2)}</span>
                </button>

                <div className="row mb-5">
                  <div className="col-md-6">
                    <div className="bg-light p-4 rounded-3 h-100">
                      <h5 className="mb-3">Conversion Summary</h5>
                      <ul className="list-unstyled">
                        <li className="mb-2 d-flex justify-content-between">
                          <span>Conversion Rate:</span> <strong>100%</strong>
                        </li>
                        <li className="mb-2 d-flex justify-content-between">
                          <span>Amount After Fees:</span> 
                          <strong>${depositInput.amount}</strong>
                        </li>
                        <li className="d-flex justify-content-between">
                          <span>Fee Percentage:</span> <strong>0%</strong>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <form onSubmit={depositSubmit} className="p-4 border rounded-3 shadow-sm bg-white">
                      <div className="mb-4">
                        <label htmlFor="amount" className="form-label fw-semibold">Enter Amount</label>
                        <input
                          type="number"
                          className="form-control"
                          id="amount"
                          placeholder="Amount in USD"
                          name="amount"
                          required
                          onChange={handleInput}
                          value={depositInput.amount}
                        />
                        <small className="text-danger">{depositInput.error_list.amount}</small>
                      </div>

                      <div className="mb-4">
                        <label htmlFor="password" className="form-label fw-semibold">Account Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Confirm Password"
                          name="password"
                          required
                          onChange={handleInput}
                          value={depositInput.password}
                        />
                        <small className="text-danger">{depositInput.error_list.password}</small>
                      </div>

                      <div className="form-check mb-4">
                        <input type="checkbox" className="form-check-input" id="terms" required />
                        <label className="form-check-label" htmlFor="terms">
                          I accept the Terms & Conditions
                        </label>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100 fw-bold py-2"
                        disabled={loading}
                      >
                        {loading ? "Processing..." : "Convert Now"}
                      </button>
                    </form>
                  </div>
                </div>

                <div className="text-center">
                  <small className="text-muted">
                    Conversion is instant. Please ensure you double-check the amount before proceeding.
                  </small>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Checkout;
